import "./instrument";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react"
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary 
      fallback={<p className="text-center py-20 text-white bg-black h-screen">Ops! Algo deu errado. Nossa equipe técnica já foi notificada.</p>} 
      showDialog
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
